import React,  { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { propsToClassKey } from '@mui/material/styles';
import Box from '@mui/material/Box';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function MembersChange({dateDebut,dateFin}) {


    const [clublist, setList] = useState("");
    const [myDateDebut, setmyDateDebut] = useState("");
    const [MyDateFin, setMyDateFin] = useState("");

    useEffect(() => {

        if(myDateDebut !== dateDebut || MyDateFin !== dateFin)
        {
            setmyDateDebut(dateDebut);
            setMyDateFin(dateFin);

                console.log("-----------"+ myDateDebut +"-------useEffect-------------------");      

                    axios.get(process.env.REACT_APP_API + '/rapports/getMembreChange/'+ myDateDebut + '/' + MyDateFin)
                    .then((res) => {     
                
                       // console.log(res.data);
                        setList(res.data);
                    
                    })
                    .catch((error) => {
                
                    });
        }
        
    });
   

    const columns = [           
        {      field: 'id',   headerName: 'id' ,  width:100,  hide:true }  ,
        {      field: 'fk_club_master',   headerName: 'Numéro club' ,  width:100, }  ,
        {      field: 'total_A_vie',      headerName: 'Total à vie' ,     width:100}  ,
        {      field: 'memberDelete',     headerName: 'Membre supprimé' ,      width:100}  ,
        {      field: 'memberAdded',      headerName: 'Membre ajouté' ,    width:100}  ,
        {      field: 'membreActif',      headerName: 'Membre actif' ,     width:100} ,        
    ];
   
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}
    return (
               
         
                
            <Box sx={{ borderRadius: 3,padding:2,margin:2, height:400,paddingBottom: 10}}  style={{ border: "1px solid grey" }}>
                <h3>Membre par club</h3>
                <DataGrid
                    
                    rows={clublist}
                    columns={columns}
                    pageSize={50}
                    rowsPerPageOptions={[25]}
                
                                            
                />           
            </Box>
     );

};

export default MembersChange;